import { useState, useCallback } from "react";

export const useEditPhoto = (initialPost) => {
  // 1. 초기 데이터 파싱
  const parsedGallery = initialPost?.gallery
    ? JSON.parse(initialPost.gallery)
    : [];

  const [formData, setFormData] = useState({
    title: initialPost?.title || "",
    date: initialPost?.date || "",
    desc: initialPost?.desc || "",
    imgUrl: initialPost?.imgUrl || "",
    gallery: parsedGallery, // 기존 서버 이미지 목록
  });

  // 2. 미리보기 및 신규 파일 상태
  const [mainImgPreview, setMainImgPreview] = useState(
    initialPost?.imgUrl
      ? `${process.env.REACT_APP_BACK_API_URL}/company/${initialPost.imgUrl}`
      : null,
  );

  const [newGalleryFiles, setNewGalleryFiles] = useState([]);

  // 3. 입력값 변경 핸들러
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const changeMainImg = (inputData) => {
    let file = inputData;

    // ✅ FileList면 첫 번째 파일만 추출
    if (inputData instanceof FileList) {
      file = inputData[0];
    }

    // 혹시 배열로 들어오는 경우까지 방어
    if (Array.isArray(inputData)) {
      file = inputData[0];
    }

    // 최종 검증
    if (!file || !(file instanceof File)) {
      console.error("❌ 파일 추출 실패:", inputData);
      return;
    }

    try {
      // 기존 blob URL 제거
      if (mainImgPreview && mainImgPreview.startsWith("blob:")) {
        URL.revokeObjectURL(mainImgPreview);
      }

      const previewUrl = URL.createObjectURL(file);

      setMainImgPreview(previewUrl);

      // 👉 여기 중요: 파일명만 넣는 건 OK (서버에서 기존값 유지용)
      setFormData((prev) => ({
        ...prev,
        imgUrl: file.name,
      }));
    } catch (error) {
      console.error("❌ 미리보기 생성 실패:", error);
    }
  };

  const removeMainImg = () => {
    setMainImgPreview(null);
    setFormData((prev) => ({ ...prev, imgUrl: "" }));
  };

  // 5. 갤러리 추가/삭제
  const addGalleryFiles = (files) => {
    const newItems = Array.from(files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      id: Math.random().toString(36).substr(2, 9),
    }));
    setNewGalleryFiles((prev) => [...prev, ...newItems]);
  };

  const removeNewFile = (id) => {
    setNewGalleryFiles((prev) => prev.filter((item) => item.id !== id));
  };

  const removeExistingImg = (imgName) => {
    setFormData((prev) => ({
      ...prev,
      gallery: prev.gallery.filter((img) => img !== imgName),
    }));
  };

  return {
    formData,
    mainImgPreview,
    newGalleryFiles,
    handleInputChange,
    changeMainImg,
    removeMainImg,
    addGalleryFiles,
    removeNewFile,
    removeExistingImg,
  };
};
